var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:push-notification-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5 4.5C22.5 6.15386 21.1539 7.5 19.5 7.5C17.8461 7.5 16.5 6.15386 16.5 4.5C16.5 2.84614 17.8461 1.5 19.5 1.5C21.1539 1.5 22.5 2.84614 22.5 4.5ZM8 3.5H13.5854C13.5286 3.83242 13.5 4.16584 13.5 4.5H8C6.06386 4.5 4.5 6.06386 4.5 8V16C4.5 17.9361 6.06386 19.5 8 19.5H16C17.9361 19.5 19.5 17.9361 19.5 16V10.5C19.8342 10.5 20.1676 10.4714 20.5 10.4146V16C20.5 18.4839 18.4839 20.5 16 20.5H8C5.51614 20.5 3.5 18.4839 3.5 16V8C3.5 5.51614 5.51614 3.5 8 3.5Z",
    fill: "#1B1B1B",
    fillOpacity: 0.8,
    stroke: "#191D23"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationicon);
export default __webpack_public_path__ + "static/media/notificationicon.28426b0dd08ebdb869ac751e57baebdf.svg";
export { ForwardRef as ReactComponent };